import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import resourcesToBackend from "i18next-resources-to-backend";
import en from "./locales/en.json";

// Eagerly bundle English so the initial render never waits on a JSON fetch.
// All other locales are split into separate chunks and loaded on demand.
i18n
  .use(
    resourcesToBackend(
      (language: string, _namespace: string) =>
        import(`./locales/${language}.json`)
    )
  )
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
    },
    partialBundledLanguages: true,
    fallbackLng: "en",
    supportedLngs: [
      "en", "de", "ar", "fr", "es", "it", "pt", "nl", "pl", "ru", "tr", "ro",
    ],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
